/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const swapSubscriptionApi = async (wcEnv, jwtToken, payload, params, headers) => {
    const data = payload.data;
    const ruleId = payload.ruleId;
    const resourcePage = `retention-subscription/passport/subscription/updateProduct/${ruleId}`;

    return restClient.putFacade(wcEnv, resourcePage, jwtToken, data, params, headers, false)
        .then((response) => response.data);
};

export default swapSubscriptionApi;
